import axios from "axios";
import { logout, updateAccessToken } from "../features/authSlice";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

let refreshPromise = null;

const refreshAccessToken = async () => {
  if (!refreshPromise) {
    refreshPromise = (async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/refresh`,
          {},
          {
            withCredentials: true,
            headers: { "X-Requested-With": "XMLHttpRequest" },
          },
        );
        const accessToken = response.data?.data?.accessToken;
        if (!accessToken) {
          throw new Error("Refresh response did not contain an access token");
        }

        const { default: store } = await import("../app/store");
        store.dispatch(updateAccessToken(accessToken));
        return accessToken;
      } finally {
        refreshPromise = null;
      }
    })();
  }

  return refreshPromise;
};
//request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const { default: store } = await import("../app/store");
    const token = store.getState().auth.accessToken;
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest?._retry &&
      !originalRequest?._skipAuthRefresh
    ) {
      originalRequest._retry = true;
      try {
        const accessToken = await refreshAccessToken();
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return axiosInstance(originalRequest);
      } catch (err) {
        const { default: store } = await import("../app/store");
        store.dispatch(logout());
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
